import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import applicationService from '../services/applicationService';
import useOrganisation from '../hooks/useOrganisation';
import ApplicationList from '../components/application/ApplicationList';
import Alert from '../components/common/Alert';
import LoadingSpinner from '../components/common/LoadingSpinner';
import FormField from '../components/common/FormField';
import './ApplicationsPage.css';

const messageFrom = (err, fallback) => err.response?.data?.message || err.message || fallback;

const ApplicationsPage = () => {
  const { organisations, organisation, select, loading: orgLoading, error: orgError } = useOrganisation();
  const [applications, setApplications] = useState(null);
  const [loadError, setLoadError] = useState('');

  const load = useCallback(() => {
    if (!organisation) return;
    setApplications(null);
    applicationService
      .list(organisation.id)
      .then((res) => setApplications(res?.data || []))
      .catch((err) => setLoadError(messageFrom(err, 'Applications could not be loaded.')));
  }, [organisation]);

  useEffect(() => { load(); }, [load]);

  if (orgLoading) return <LoadingSpinner />;

  if (!organisation) {
    return (
      <div className="applications-page">
        {orgError && <Alert type="error" message={orgError} />}
        <div className="card">
          <div className="card-body">
            <h2>Set up your organisation first</h2>
            <p>Applications belong to properties, which belong to an organisation. It takes a minute to create one.</p>
            <Link to="/get-started" className="btn-primary">Get started</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="applications-page">
      <div className="page-header">
        <h1 className="page-title">Applications</h1>
        {/* Invitations are sent per property, from that property's page — see PropertyDetail. */}
        <Link to="/properties" className="btn-primary">Go to Properties to invite an applicant</Link>
      </div>

      {organisations.length > 1 && (
        <FormField
          label="Organisation"
          name="organisation"
          type="select"
          options={organisations.map((o) => ({ value: String(o.id), label: o.name }))}
          value={String(organisation.id)}
          onChange={(e) => select(e.target.value)}
        />
      )}

      {loadError && <Alert type="error" message={loadError} />}

      <div className="card">
        <div className="card-body">
          <ApplicationList applications={applications || []} loading={applications === null && !loadError} />
        </div>
      </div>
    </div>
  );
};

export default ApplicationsPage;
